import createReducer from '../../createReducer';
import {
  FETCH_GRAPH_WIND_FORECAST,
  FETCH_GRAPH_WIND_FORECAST_SUCCESS,
  FETCH_GRAPH_WIND_FORECAST_FAILURE,
} from '../../../actions/graphs';
import transformDataToDays from './helpers/transformDataToDays';

const initialState = {
  error: null,
  loading: true,
  units: null,
  utcOffset: null,
  location: null,
  overallMaxSpeed: null,
  days: null,
};

const handlers = {};

handlers[FETCH_GRAPH_WIND_FORECAST] = () => initialState;

handlers[FETCH_GRAPH_WIND_FORECAST_SUCCESS] = (state, { intervalHours, response }) => ({
  ...state,
  loading: false,
  units: response.associated.units,
  utcOffset: response.associated.utcOffset,
  location: response.associated.location,
  overallMaxSpeed: Math.max(...response.data.wind.map(({ speed }) => speed)),
  days: transformDataToDays(
    response.data.wind,
    intervalHours,
  ),
});

handlers[FETCH_GRAPH_WIND_FORECAST_FAILURE] = (state, { error }) => ({
  ...state,
  error,
  loading: false,
});

export default createReducer(handlers, initialState);



// WEBPACK FOOTER //
// ./src/reducers/components/graphs/wind.js